/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim2DiagMinRightIcon24Solid = forwardRef('ArrowDim2DiagMinRightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M21.884 3.884a1.25 1.25 0 0 0-1.768-1.768L14.25 7.982V4.5a1.25 1.25 0 1 0-2.5 0v5.25a2.5 2.5 0 0 0 2.5 2.5h5.25a1.25 1.25 0 1 0 0-2.5h-3.482l5.866-5.866Z" }),
        React.createElement("path", { d: "M9.75 19.5v-3.482l-5.866 5.866a1.25 1.25 0 0 1-1.768-1.768l5.866-5.866H4.5a1.25 1.25 0 1 1 0-2.5h5.25a2.5 2.5 0 0 1 2.5 2.5v5.25a1.25 1.25 0 1 1-2.5 0Z" })));
});
